import { render } from "./PartnershipPopover.vue?vue&type=template&id=4d491ce9&scoped=true&ts=true"
import script from "./PartnershipPopover.vue?vue&type=script&lang=ts"
export * from "./PartnershipPopover.vue?vue&type=script&lang=ts"

import "./PartnershipPopover.vue?vue&type=style&index=0&id=4d491ce9&scoped=true&lang=css"

import exportComponent from "/home/runner/work/angelleague-front/angelleague-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d491ce9"]])

export default __exports__